import cn from 'classnames'

type InfoValueProps = { className?: string }

const InfoValue: React.FC<InfoValueProps> = ({ children, className }) => {
  return <dd className={cn('mt-1 text-sm text-gray-900', className)}>{children}</dd>
}

export { InfoValue }
